<template>
    <div>
        <span
            v-show="finalViewonly"
            :class="prefixCls + '-text-content'"
        >{{ textContent }}</span>
        <div v-show="!finalViewonly">
            <check-tag
                v-if="multiple && checkAll"
                v-bind="$attrs"
                checkable
                name="__all__"
                key="__all__"
                :color="color"
                :checked="isAllCheck"
                @on-change="onChckAllChange"
            >
                全部
            </check-tag>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import Field from '../../mixins/field';
import CheckTag from "./check-tag";
import { findComponentsDownward, oneOf } from '../../utils/assist'
import Filterable from '../filter/filterable'

const prefixCls = 'ivu-check-tag-group';

export default {
    name: 'CheckTagGroup',
    
    inheritAttrs: false,
    
    mixins: [Filterable, Field],
    
    composed: true,
    
    components: {
        CheckTag
    },
    
    props: {
        checkAll: {
            type: Boolean,
            default: false,
        },
        
        value: {
            type: Array,
            default () {
                return []
            }
        },
        color: {
            type: String,
            default: 'default'
        },
        // 是否多选
        multiple: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            childrens: []
        };
    },
    
    computed: {
        prefixCls() {
            return prefixCls
        },
        isAllCheck() {
            return this.value.length == this.childrens.length
        },
        textContent() {
            return this.childrens
                .filter(v => Boolean(v.isChecked)).map(v => v.$el.textContent.trim()).join(",")
        },
    },
    
    mounted() {
        this.updateChildren()
    },
    
    methods: {
        // 更新所有child的check状态
        updateChildren() {
            if (this.multiple) {
                if (this.childrens) {
                    this.childrens.forEach(child => {
                        child.isGroup = true
                        child.isChecked = this.value.findIndex(v => v == child.name) >= 0
                    })
                }
            } else {
                if (this.childrens) {
                    this.childrens.forEach(child => {
                        child.isGroup = true
                        if (typeof(this.value) == "string" && typeof(this.value) == "number") {
                            if (child.name == value) {
                                child.isChecked = true
                            } else {
                                child.isChecked = false
                            }
                        } else if (typeof(this.value) == "object") {
                            if (child.name == this.value[0]) {
                                child.isChecked = true
                            } else {
                                child.isChecked = false
                            }
                        }
                    })
                }
            }
        },
        
        // child change
        updateChild(checked, name) {
            var newValue = [...this.value]
            if (this.multiple) {
                if (checked) {
                    newValue.push(name)
                } else {
                    var targetIndex = newValue.findIndex(v => v == name)
                    newValue.splice(targetIndex, 1)
                }
            } else {
                if (checked) {
                    newValue = [name]
                } else {
                    newValue = []
                }
            }
            
            this.dispatchChange(newValue)
        },
        
        onChckAllChange(checked, name) {
            checked ? this.selectAll() : this.deSelectAll()
        },
        
        selectAll() {
            this.dispatchChange(this.childrens.map(v => v.name))
        },
        
        deSelectAll() {
            this.dispatchChange([])
        },
        
        dispatchChange(val) {
            this.$emit("input", val)
            this.$emit("on-change", val)
            this.dispatchFormChange(val)
        },
        
        addChild(child) {
            if (child.name != "__all__") {
                this.childrens.push(child)
            }
            if (child.finalColor == 'default') {
                child.finalColor = this.color
            }
        },
        
        removeChild(child) {
            this.childrens.splice(this.childrens.findIndex(v => v === child), 1)
        }
    },
    
    watch: {
        value() {
            this.updateChildren()
        },
        childrens() {
            this.updateChildren()
        }
    }
};
</script>